<template>
  <div>
    <h4 class="mb-4">{{ $t('homelab.labels.client_info') }}</h4>

    <div class="row">
      <div class="col-12 col-md-3 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.name') }}</label>
        <br>
        <span>{{ appointment.name }}</span>
      </div>

      <div class="col-12 col-md-3 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.email') }}</label>
        <br>
        <span>{{ appointment.email }}</span>
      </div>

      <div class="col-12 col-md-3 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.birthdate') }}</label>
        <br>
        <span>{{ moment(appointment.birthdate).format("DD/MM/YYYY") }}</span>
      </div>

      <div class="col-12 col-md-3 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.health_number') }}</label>
        <br>
        <span>{{ appointment.health_number }}</span>
      </div>

      <div class="col-12 col-md-3 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.tax_number') }}</label>
        <br>
        <span>{{ appointment.tax_number }}</span>
      </div>

      <div class="col-12 col-md-3 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.gender') }}</label>
        <br>
        <span>{{ $t(`genders.${appointment.gender}`) }}</span>
      </div>

      <div class="col-12 col-md-3 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.phone') }}</label>
        <br>
        <span>{{ appointment.phone_number }}</span>
      </div>

      <div v-if="appointment.client_number" class="col-12 col-md-3 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.client_number') }}</label>
        <br>
        <span>{{ appointment.client_number }}</span>
      </div>

      <div class="col-12">
        <label class="is-bold mb-0">{{ $t('homelab.labels.address') }}</label>
        <br>
        <span>{{ formattedAddressLine1 }}</span>
        <br>
        <span>{{ formattedAddressLine2 }}</span>
      </div>

    </div>
  </div>

</template>

<script>
export default {
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedAddressLine1: function () {
      return [this.appointment.address.line1, this.appointment.address.line2, this.appointment.address.door_number].filter(v => v).join(', ')
    },
    formattedAddressLine2: function () {
      return [this.appointment.address.city, this.appointment.address.postal_code].filter(v => v).join(', ')
    }
  }
}
</script>
